var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(1 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.76470588 17.4455912h10.32352942c.4385791 0 .7941176-.3555386.7941176-.7941176v-7.14705886"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.58823529 17.4455912h2.38235295c.43857906 0 .79411764-.3555386.79411764-.7941176v-7.14705886",
    transform: "matrix(-1 0 0 1 6.352942 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m.75 5.53382651h15.9705882c.4142136 0 .75.33578644.75.75v2.47058823c0 .41421357-.3357864.75-.75.75h-15.9705882c-.41421356 0-.75-.33578643-.75-.75v-2.47058823c0-.41421356.33578644-.75.75-.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.73529412 17.4455912v-11.91176469"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.2511765 3.2880618c-1.3306247 1.04348314-2.8583681 1.80735489-4.49152944 2.24576471.43840982-1.6331613 1.20228156-3.16090478 2.24576474-4.49152941 1.3965882-1.39552942 2.1875294-1.18164706 2.8122353-.56117647.6247058.62047058.8301176 1.41141176-.5664706 2.80694117z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m4.21835294 3.2880618c1.33074978 1.04328543 2.8584512 1.80713615 4.49152941 2.24576471-.43791651-1.6333486-1.20183574-3.16118704-2.2457647-4.49152941-1.39552941-1.39552942-2.18647059-1.18164706-2.81117647-.56117647-.62470589.62047058-.83011765 1.41141176.56541176 2.80694117z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.62c8715b9a29b5ea0e81ea9905c5b3d7.svg";
export { ForwardRef as ReactComponent };